// vim: set ts=2 sts=2 sw=2 et:

import { JUDGE_POSITIONS } from "../judging/resolveJudgeVotes";
import type { JudgeLights } from "./platformLiveProtocol";

// The server streams the running lights to every role as each judge votes. Public displays (Spectator
// Display and Broadcast Overlay) show the three together once all voted, never one by one.
export const judgeLightsShownTogether = (lights: JudgeLights): JudgeLights =>
  JUDGE_POSITIONS.every((position) => lights[position] !== "off") ? lights : { J1: "off", J2: "off", J3: "off" };
